<template>
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">Reporte de pluviómetros por horas</h1>
            </div><!-- /.col -->
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                <li class="breadcrumb-item active">Pluviometros x hora</li>
              </ol>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /.container-fluid -->
      </div>
      <!-- /.content-header -->

      <!-- Main content -->
      <div class="content">
        <div class="container-fluid">

          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Reporte</h5>

                  <div class="card-text">
                    <div class="row">
                      <div class="col-lg-12">
                        <button @click="actualizar()">test</button>
                        <b-table small bordered striped hover :items="items" :fields="fields"></b-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->

        </div><!-- /.container-fluid -->
      </div>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
</template>

<script>
export default {
  data () {
    return {
      urlconfig: null,
      items: [],
      fields: []
    }
  },
  mounted: function () {
    var obj = this
    this.$http.post(this.$store.state.apiurl + '/api-token-auth/', { username: 'admin', password: 'admin1' }).then(function (valx) {
      obj.urlconfig = {
        credentials: true,
        headers: { 'Authorization': 'Token ' + valx.body.token }
      }
    })
  },
  methods: {
    actualizar () {
      var obj = this
      var url = this.$store.state.apiurl + '/mediciones_horas/' + 2018 + '/' + 12 + '/' + 1
      this.$http.get(url, this.urlconfig).then(function (val) {
        this.items = val.data.items
        this.fields = []
        for (var i = 0; i < val.data.fields.length; i++) {
          var field = { 'key': val.data.fields[i], 'tdClass': obj.formatear }
          if (val.data.fields[i] === 'Horas') { field['class'] = 'negrita' }
          this.fields.push(field)
        }
      })
    },
    formatear (value, key, item) {
      var resp = ['bordes']
      if (item['Horas']>5 && item['Horas']<18 ){
        resp.push('color_fondo')
      }
      if (key!=='Horas'){
        resp.push('celda_derecha')
      }
      return resp
    }
  }
}
</script>

<style>
.negrita {
  font-weight: bold;
}
.color_fondo {
  background-color:rgb(217,217,217);
}
.table th, .table td {
  border-color: black;
}
.celda_derecha{
  text-align:right;
}
</style>